
    <div class="page-container home-container">
        <p class="text">Before you start testing:</p>
        <div class="center-container">
            <div class="steps">
                <div class="step"><img src="/assets/images/icons/binding.svg" alt="">
                    <div>Ensure the binding process has been successful.</div>
                </div>
                <div class="step"><img src="/assets/images/icons/electricity.svg" alt="">
                    <div>Ensure the keynexis® storage unit control is
                        <b>powered by 24 volts.</b>
                    </div>
                </div>
                <div class="step"><img src="/assets/images/icons/wifi.svg" alt="">
                    <div>Ensure the keynexis® storage unit control is
                        <b>connected to Wi-Fi.</b>
                    </div>
                </div>
                <div class="step"><img src="/assets/images/icons/door.svg" alt="">
                    <div>Ensure the storage unit <b>door is closed.</b></div>
                </div>
                <div class="step optional"><img src="/assets/images/icons/sensor.svg" alt="">
                    <div> If a motion sensor is connected, move inside the storage unit right after the door opens
                        automatically.</div>
                </div>
            </div>
        </div>
        <div class="actions">
            <button mat-flat-button (click)="startApp()"> Start Testing</button>
        </div>
    </div>
